import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import OnlineStatus from './OnlineStatus'

interface Props {
  title: string
  back?: boolean | (() => void)
  right?: ReactNode
}

export default function AppBar({ title, back, right }: Props) {
  const navigate = useNavigate()
  const showBack = !!back
  const onBack = () => {
    if (typeof back === 'function') back()
    else navigate(-1)
  }
  return (
    <header className="app-bar">
      {showBack && <button className="back-btn" onClick={onBack}>Back</button>}
      <h1>{title}</h1>
      <OnlineStatus />
      {right}
    </header>
  )
}
